module.exports = __webpack_public_path__ + "img/1440.74958f10.jpg";